import { types, actions } from './requests'
export const CREATEBADGESCAN_TYPES = {
    ...types('CREATEBADGESCAN'),
}
export const CREATEBADGESCAN_ACTIONS = {
    ...actions('CREATEBADGESCAN'),
}